import $ from "jquery";
import { isNumberOutOfRange, round } from "../utils/math";
import { trim } from "./General";
import { currentCultureSettings } from "./setCulture";

"use strict";

export const numericUtility = {
    jsDecimalSeparator: '.',

    getDecimalSeparator: function(){
        return currentCultureSettings.decimalSeparator;
    },

    getCurrencyGroupSeparator: function(){
        return currentCultureSettings.currencyGroupSeparator;
    },

    getCurrencyDecimalSeparator: function() {
        return currentCultureSettings.currencyDecimalSeparator;
    },

    shortFormatMoney: function(number) {
        let sign = number >= 0 ? '' : '-';
        let numberAbs = Math.abs(number);

        if (numberAbs < 1000) {
            return this.formatMoney(number);
        }

        var postfix = "K";
        var roundVal = 1000;
        if (numberAbs >= 1000000) {
            postfix = "M";
            roundVal = 1000000;
        }

        var value = numberAbs / roundVal;
        var textVal = value.toString();

        var sep = this.getDecimalSeparator();
        return sign + textVal.replace(/^(\d*)\.?(\d*)?$/, function (match, left, right) {
            right = right || "";
            var res = left;
            if (left.length < 3) {
                res += sep + (right + "00").substring(0, 3 - left.length);
            }

            return res;
        }) + postfix;
    },

    formatLocal: function(number, maxDecimalsCount, maxRoundDecimalsCount = 6) {
        var separator = this.getDecimalSeparator();
        var value = (number === null || number === undefined || number === "") ?
            "" : round(this.parseLocal(number), maxRoundDecimalsCount);
        var result =  value.toString().replace(this.jsDecimalSeparator, separator);
        if(maxDecimalsCount !== undefined && result.indexOf(separator) !== -1){
            var index = result.indexOf(separator);
            result = result.substr(0, index + maxDecimalsCount + 1);
        }
        return result;
    },

    parseLocal: function(stringValue){
        if(typeof stringValue === 'number')
            return stringValue;

        var separator = this.getDecimalSeparator();
        var replaced = stringValue.replace(separator, this.jsDecimalSeparator);

        return parseFloat(replaced);
    },

    moneyWithCurrency: function (value, currencySymbol) {
        var result = value;
        if (currencySymbol) {
            var format = currentCultureSettings.moneyWithCurrencyFormat;
            result = format.replace("{v}", result).replace("{c}", currencySymbol);
        }

        return result;
    },

    formatMoneyWithCurrency: function(value, currencySymbol){
        var result = this.formatMoney(value);
        return this.moneyWithCurrency(result, currencySymbol);
    },

    formatMoney: function(value, withoutGroup){
        if(value == null){
            return "";
        }

        if(typeof(value) === 'string'){
            value = parseFloat(value);
        }

        if (isNumberOutOfRange(value)) {
            return value;
        }

        return this.setGroupSeparator(value, true, withoutGroup);
    },

    parseMoney: function(stringValue){
        const separator = this.getCurrencyDecimalSeparator();
        const groupSeparator = this.getCurrencyGroupSeparator();
        let normalizedValue = stringValue;

        while(normalizedValue.indexOf(groupSeparator) !== -1){
            normalizedValue = normalizedValue.replace(groupSeparator, '');
        }
        normalizedValue = normalizedValue.replace(separator, this.jsDecimalSeparator);

        return normalizedValue ? parseFloat(normalizedValue) : 0;
    },

    formatPercentage: function(value, maxRoundDecimalsCount = 6){
        return this.formatLocal(value, 2, maxRoundDecimalsCount) + "%";
    },

    //TODO : remove this function and use format money
    setGroupSeparator: function(value, forceDecimalPart, withoutGroups) {
        var nStr = value + '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? this.getCurrencyDecimalSeparator() + x[1] : '';

        if(forceDecimalPart){
            if(x2.length === 0){
                x2 = this.getCurrencyDecimalSeparator() + '00';
            }else if(x2.length === 2){
               x2 += '0';
            }else{
                x2 = x2.substring(0, 3);
            }
        }

        if(!withoutGroups){
            const rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + this.getCurrencyGroupSeparator() + '$2');
            }
        }
        return x1 + x2;
    },

    getMoneyPlaceholder: function(){
        return numericUtility.formatMoney(0);
    },

   toFixed: (val, fractionDigits) => parseFloat(val.toFixed(fractionDigits)),
};

$.fn.numVal = function (number) {
    if (typeof number !== "undefined") {
        if (typeof number === "string")
            number = numericUtility.parseLocal(number);

        if (number == null || typeof number === "number") {
            this.val(numericUtility.formatLocal(number || 0));
        }
    }
    const value = trim(this.val());
    return numericUtility.parseLocal(value || 0);
};

ep.numericUtility = numericUtility;